"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeAccount = exports.decodeMint = exports.decodeVault = exports.decodeMultipleAccounts = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
function decodeMultipleAccounts(program, params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    return __awaiter(this, void 0, void 0, function* () {
        const accountKeys = [];
        const accountTypes = [];
        for (const x of params) {
            accountKeys.push(x.publicKey);
            accountTypes.push(x.accountType);
        }
        const accountInfos = yield anchor_1.utils.rpc.getMultipleAccounts(program.connection, accountKeys);
        return accountInfos.map((accountInfo, i) => {
            if (!accountInfo) {
                throw new Error("Account " + accountKeys[i] + " does not exist");
            }
            const data = accountInfo.account.data;
            switch (accountTypes[i]) {
                case "Vault":
                    return decodeVault(program, data);
                case "Account":
                    return decodeAccount(data);
                case "Mint":
                    return decodeMint(data);
                default:
                    console.log(accountInfo);
                    throw new Error("Non-valid account type " + accountTypes[i]);
            }
        });
    });
}
exports.decodeMultipleAccounts = decodeMultipleAccounts;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function decodeVault(program, data) {
    return program.coder.accounts.decode("VaultAccount", data);
}
exports.decodeVault = decodeVault;
function decodeMint(data) {
    return spl_token_1.MintLayout.decode(data);
}
exports.decodeMint = decodeMint;
function decodeAccount(data) {
    return spl_token_1.AccountLayout.decode(data);
}
exports.decodeAccount = decodeAccount;
//# sourceMappingURL=decoder.js.map